import React, { useState, useEffect } from "react";

import Autocomplete from "../ui/Autocomplete";
import NuxeoClient from "../../clients/NuxeoClient";

import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import InputLabel from "@material-ui/core/InputLabel";
import ReactGA from "react-ga";

import { useI18n } from "../../I18nProvider";

export default function Retailer(props) {
  const appText = useI18n();
  const [fetchedData, setFetchedData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    _loadRetailers();
  }, []);

  async function _loadRetailers() {
    await NuxeoClient.instance()
      .fetchRetailers()
      .then((response) => {
        setFetchedData(response);
        setIsLoading(false);
      });
  }

  const handleChange = (values) => {
    if (values === null) {
      props.handleChange("retailer", []);
    } else {
      let result = values.map((value) => value.label);
      props.handleChange("retailer", result);
      //Track Retailer Field on GA
      ReactGA.event({
        category: "Form",
        action: "Field Value Selected",
        transport: "beacon",
        label: `Retailer Selected - ${result}`,
      });
    }
  };

  return (
    <>
      {/* <Tooltip arrow title="Please select intended retailer(s)."> */}
      <Tooltip arrow title={appText.T119}>
        <Grid item={true} xs={12}>
          <div id="retailer">
            <InputLabel className="field-label field-dropdown" required>
              {appText.T56}
            </InputLabel>
            <Autocomplete
              type={"multi"}
              handleChange={handleChange}
              data={fetchedData}
              dataType={"retailer"}
              mapVariable={"label"}
              setFilterData={() => null}
              value={props.value}
              isLoading={isLoading}
            />
          </div>
        </Grid>
      </Tooltip>
    </>
  );
}
